{#if teachers?.length}
    <div class="itsl-course-info-box__teachers">
        <h3 class="itsl-course-info-box__teachers__title">{courseTeachersTitle}</h3>
        <ul class="itsl-course-info-box__teachers__list">
            {#each teachers as teacher}
                <li>
                    <Profile
                        size={teacherAvatarSize}
                        src={teacher.profileUrl}
                        name={teacher.fullName}
                    />
                </li>
            {/each}
        </ul>
    </div>
{/if}

<script>
    import Profile from "@itslearning/prometheus/assets/nodes/Profile/v1/Profile.svelte";

    import { teacherAvatarSize } from "../../constants";
    import config from "../../config";

    export let courseTeachersTitle;

    const teachers = config.teachers;
</script>
